var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-gap-2 tw-items-start"},[_c('img',{staticClass:"tw-h-[70px] tw-mr-2",attrs:{"src":require('@/assets/images/onboarding/doctor-image.png'),"alt":""}}),_c('h2',{staticClass:"tw-mb-0 tw-flex-1 question-title tw-font-atten"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }